<template>
  <div :style="outerStyle" class="outer-style">
    <div class="write-letter-editor">
      <div class="columns">
        <div class="edit-column">
          <div class="preview-logo">
            <img
              :src="`${this.storage_url}/cut-letter/preview-logo.jpeg`"
            />
          </div>
          <wysiwyg
            ref="wysiwyg-1"
            id="col1"
            v-model="letterContent.column_1"
            @input.native="inputHandle"
            @keydown.native="keyHandle"
            v-click-outside="saveLetter"
          />
        </div>
        <div class="edit-column">
          <div class="preview-logo">
            <img
              :src="`${this.storage_url}/cut-letter/preview-logo.jpeg`"
            />
          </div>
          <wysiwyg
            ref="wysiwyg-2"
            id="col2"
            v-model="letterContent.column_2"
            @input.native="inputHandle"
            @keydown.native="keyHandle"
            v-click-outside="saveLetter"
          />
        </div>
      </div>
    </div>
    <div class="buttons">
      <button @click="changeZoom(5)">Zoom +</button>
      <button @click="changeZoom(-5)">Zoom -</button>
      <button variant="" @click="saveLetter()" :disabled="saved">
        {{ btnText }}
      </button>
      <button variant="" @click="previewLetter()">Preview</button>
      <button @click="resetLetter()">Reset</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import wysiwyg from 'vue-wysiwyg'

let loader

Vue.use(wysiwyg, {
  hideModules: {
    image: true,
    table: true,
    justifyRight: true,
    headings: true,
    separator: true,
    removeFormat: true,
    unorderedList: true,
    orderedList: true
  },
  maxHeight: '1050px'
})

export default {
  name: 'LetterContent',
  data () {
    return {
      saved: true,
      letterContent: {
        column_1: '',
        column_2: ''
      },
      orderId: null,
      saving: false,
      btnText: 'Save',
      zoom: 60,
      storage_url: process.env.VUE_APP_CDN_BASE_URL
    }
  },
  computed: {
    outerStyle () {
      return 'zoom: ' + this.zoom + '%;'
    }
  },
  methods: {
    changeZoom (change) {
      this.zoom += change
    },
    autoSetZoom () {
      var interfaceBuffer = 130
      var screenHeight = window.innerHeight - interfaceBuffer
      var fullHeight = 1100
      var zoomSuggest = Math.round((screenHeight / fullHeight) * 100)
      this.zoom = zoomSuggest
    },
    saveLetter () {
      let loader
      if (!this.saved) {
        Vue.api.patch('/order/letter', {
          orderId: this.$route.query.id,
          col1: this.letterContent.column_1,
          col2: this.letterContent.column_2
        }, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: () => this.saved = true
        })
      }
    },
    resetLetter () {
      if (
        confirm('Letter will be replaced with original template. Are you sure?')
      ) {
        Vue.api.delete(`/order/${this.orderId}/letter`, {}, {
          callback: () => location.reload(),
          error: () => {}
        })
      }
    },
    inputHandle (e) {
      this.saved = false
    },
    previewLetter () {
      window.open(
        process.env.VUE_APP_API_URL + `letter/preview/${this.orderId}`
      )
    },
    keyHandle (e) {
      const hasScrollBar = e.target.scrollHeight > e.target.clientHeight
      if (hasScrollBar) {
        e.target.classList.add('unhappy')
        if ([8, 46].indexOf(event.which) == -1) {
          event.preventDefault()
        }
      } else e.target.classList.remove('unhappy')
    }
  },
  watch: {
    saving (value) {
      if (value) {
        this.btnText = 'Saving...'
      } else {
        this.btnText = 'Save'
      }
    }
  },
  mounted () {
    this.orderId = this.$route.query.id
    this.autoSetZoom()

    window.addEventListener('resize', () => {
      this.autoSetZoom()
    })

    Vue.api.get(`/order/${this.orderId}/letter`, {}, {
      before: () => loader = this.$loading.show(),
      always: () => loader.hide(),
      callback: res => {
        this.letterContent = res
      }
    })
  },
  created () {
    window.addEventListener('beforeunload', this.saveLetter)
    setInterval(this.saveLetter, 10 * 1000)
  },
  beforeDestroy () {
    this.saveLetter()
  }
}
</script>

<style lang="less" scoped>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";

.outer-style {
  transition: 200ms;
}
.columns {
  display: flex;
}
.columns .edit-column {
  position: relative;
  width: 625px;
  height: 1100px;
  padding-top: 30px;
  font-family: "Calibri";
  font-size: 22.5px;
  line-height: 22.5px;
  font-weight: normal;
}
.edit-column .preview-logo {
  position: absolute;
  top: -50px;
  left: 300px;
  background: #fff;
  text-align: center;
  width: 80px;
}
.edit-column .preview-logo img {
  height: 50px;
}
.columns .edit-column:nth-child(1) {
  margin-right: 20px;
}
.columns .edit-column:nth-child(2) {
  margin-left: 20px;
}
.write-letter-editor {
  margin: 30px;
  margin-left: auto;
  margin-right: auto;
  padding: 30px;
  border: 1px solid #d18f60;
  width: 1435px;
  display: flex;
  justify-content: center;
}
/deep/.editr {
  position: relative;
}
/deep/.editr .editr--toolbar {
  position: absolute;
  top: -36px;
  display: none;
}
/deep/.columns .edit-column:hover .editr--toolbar {
  display: flex;
}
.buttons {
  position: fixed;
  left: 15px;
  top: 0px;
  bottom: 0px;
  display: flex;
  /*align-items: center;*/
  justify-content: center;
  flex-direction: column;
}
.buttons button {
  margin-top: 5px;
  margin-bottom: 5px;
}
/deep/.editr--content {
  padding: 0px;
  height: 1050px;
}
/deep/.editr--content.unhappy {
  border: 3px solid red;
}
</style>
